import type { BeforeInstallPromptEvent, InstallType } from './typings';

export { default as getAppInstallType } from './getAppInstallType';

export const beforeinstallprompt = 'beforeinstallprompt' as keyof WindowEventMap;
export type { BeforeInstallPromptEvent, InstallType };